import React from 'react';
import {connect} from 'react-redux'

import {_Object} from "../utils/utils";
import {Theme} from '../theme/index';
import * as svgData  from './svg';

class Svg extends Theme {
    constructor(props) {
        super(props);
        let _state = {};
        this.state = _Object.merge(this.state || {}, _state)
    };

    render() {
        let props = this.props;
        let SvgDom = svgData[props.type || "RadioOn"];

        let themeName =  this.props.theme || "default";
        let _theme = this.state.theme[themeName];

        return <SvgDom width={props.width} height={props.height} fill={props.fill} style={props.style}
                       svgTheme={_theme.svg}/>
    }
}

const mapStateToProps = state => {
    return {
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Svg)